(() => {
 const link = document.querySelector('[data-ihn-return]');
 if (!link || !document.referrer) return;
 let previous;
 try { previous = new URL(document.referrer); } catch { return; }
 if (previous.origin !== location.origin || previous.pathname === location.pathname) return;
 const path = previous.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/)/i, '');
 const pageType = link.dataset.pageType;
 let label = '';
 if (pageType === 'product' && /^\/collections\/(?![^/]+\/products\/)[^/]+\/?$/.test(path)) label = link.dataset.collectionLabel;
 else if (pageType === 'product' && /^\/search\/?$/.test(path)) label = link.dataset.searchLabel;
 else if (pageType === 'collection' && /^\/collections\/[^/]+\/?$/.test(path)) label = link.dataset.collectionLabel;
 else if ((pageType === 'product' || pageType === 'collection') && /^\/pages\/(vloeren|wandpanelen|traprenovatie|raamdecoratie|projecten-interieur-inspiratie)\/?$/.test(path)) label = link.dataset.overviewLabel;
 if (!label) return;
 previous.searchParams.delete('preview_theme_id');
 previous.searchParams.delete('_fd');
 previous.searchParams.delete('pb');
 link.href = previous.pathname + previous.search + previous.hash;
 link.querySelector('[data-ihn-return-label]').textContent = label;
})();